import { createApp, h } from 'vue';
import App from './presentation/app.vue';
import GlobalsPlugin from './vue-globals';
import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import store from '@/store';
import { LoginStatusChecker } from '@/misc/LoginStatusChecker';
import { IShared } from '@/infrastructure/Shared';
import { ISnowplow } from '@/infrastructure/ISnowplow';
import { PortalType } from '@/interfaces/PortalType';
import { IRenderPayload } from '@/interfaces/published/IRenderPayload';

declare global {
	interface Window {
		Rollbar?: {
			error: (message: Error | string) => void;
		};
		rollbarIgnore: (...args: any) => boolean;
		snowplow?: ISnowplow;
		hj?: (event: string, actionName: string) => void;
		EventAggregationService: IEventAggregationService;
		PortalType?: PortalType;
		Shared?: IShared;
	}
}

new LoginStatusChecker().initiate();
void store.actions.loadLocalStorage();

const renderWidgets = (payload: IRenderPayload): void => {
	if (payload.organisationId) {
		const node: Element | undefined = document
			.querySelectorAll(`[data-reviews-widget="${payload.widget}"][data-organisation-id="${payload.organisationId}"]`)
			.values()
			.next().value;

		if (node === undefined) return;
		renderWidget(payload, node);
		return;
	}

	const nodes: NodeListOf<Element> = document.querySelectorAll('[data-reviews-widget]');
	for (const node of nodes) {
		renderWidget(payload, node);
	}
};

const renderWidget = (payload: IRenderPayload, node: Element): void => {
	const reviewsWidget = node.getAttribute('data-reviews-widget');
	if (reviewsWidget !== payload.widget) return;
	const reviewsReferrer = payload.reviewsReferrer;
	const isSingleBadge = payload.isSingleBadge;
	const isSmall = payload.isSmall;
	const isOpen = payload.isOpen;

	const organisationId = node.getAttribute('data-organisation-id');

	const reviews = createApp({
		render: () => {
			return h(App, {
				reviewsWidget,
				reviewsReferrer: reviewsReferrer ?? null,
				organisationId,
				isSingleBadge: isSingleBadge ?? null,
				isSmall: isSmall ?? false,
				isOpen: isOpen ?? null,
			});
		},
	});

	reviews.use(GlobalsPlugin);
	reviews.mount(node);
};

document.addEventListener('RenderReviewsWidgets', (evt: unknown): void => {
	const event = evt as CustomEvent<IRenderPayload>;

	if (event.detail === undefined) {
		return;
	}

	renderWidgets(event.detail);
});

document.dispatchEvent(new CustomEvent('ReviewsMicroserviceFetched'));
